import _ from 'lodash';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CoreModule } from 'app/core/core.module';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CommonModule } from '@angular/common';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { NgxCurrencyDirective } from 'ngx-currency';

@Component({
  standalone:true,
  selector: 'app-user-role-cell',
  templateUrl: './user-role-cell.component.html',
  styleUrls: ['./user-role-cell.component.scss'],
  imports:[FormsModule,ReactiveFormsModule,MdbSelectModule,CoreModule,CommonModule,MdbAutocompleteModule,GoogleMapsAutocompleteModule, NgxCurrencyDirective]
})
export class UserRoleCellComponent implements OnInit {
    @Input()
    public data: any = {};

    public list: string[] = [];
    public roles = {
      1: "Account Admin",
      2: "Campaign Manager",
      3: "Event Manager",
      4: "Finance"
    };

    constructor() { }

    ngOnInit(): void {
      const access = this.data.access || [1];
      for(let role of access) {
        this.list.push(this.roles[role]);
      }
    }
}
